import { render, staticRenderFns } from "./Medicine.vue?vue&type=template&id=15813b74&scoped=true"
import script from "./Medicine.vue?vue&type=script&lang=js"
export * from "./Medicine.vue?vue&type=script&lang=js"
import style0 from "./Medicine.vue?vue&type=style&index=0&id=15813b74&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15813b74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15813b74')) {
      api.createRecord('15813b74', component.options)
    } else {
      api.reload('15813b74', component.options)
    }
    module.hot.accept("./Medicine.vue?vue&type=template&id=15813b74&scoped=true", function () {
      api.rerender('15813b74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Medicine.vue"
export default component.exports